<template>
  <v-card>
    <v-card-title class="section-title pt-6 pb-2 mb-0">
      <span>Configurações dos Hotsites</span>
      <v-spacer />
      <add-hotsite-slot :add-hotsite-fn="addHotsite" />
    </v-card-title>
    <v-card-text>
      <paginated-data-table ref="table" :headers="headers" :query="query" query-name="hotsiteSlots" query-main-property-name="slots">
        <template #item.name="{ item }">
          <a class="link" @click.prevent="goToHotsiteSlot(item)">{{ item.name }}</a>
        </template>
        <template #item.urls="{ item }">
          <v-chip v-for="url in item.urls" :key="url" class="mr-2" @click="openUrl(url)">
            {{ url }}
          </v-chip>
        </template>
        <template #item.latest_version="{ item }">
          {{ item.latest_version }}
        </template>
        <template #item.menu="{ item }">
          <v-menu bottom origin="center center" transition="scale-transition">
            <template v-slot:activator="{ on }">
              <mf-button type="icon" icon="more_vert" color="cinza-0" v-on:click.native="on.click" />
            </template>
            <v-list>
              <v-list-item @click="goToHotsiteSlot(item)">
                <v-list-item-title>Editar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteHotsiteSlot(item)">
                <v-list-item-title>Deletar</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </paginated-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { LIST_HOTSITE_SLOTS, ADD_HOTSITE_SLOT, DELETE_HOTSITE_SLOT } from '@/modules/configuracoes/site-de-cadastramento/graphql'

export default {
  name: 'HotsiteSlotsTable',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    AddHotsiteSlot: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/AddHotsiteSlot.vue'),
  },
  data: () => ({
    headers: [
      {
        text: 'Nome',
        value: 'name',
      },
      {
        text: 'URLs',
        value: 'urls',
      },
      {
        text: 'Versão mais recente',
        value: 'latest_version',
        width: 200,
      },
      {
        text: '',
        value: 'menu',
        width: 20,
        sortable: false,
      },
    ],
  }),
  computed: {
    query() {
      return LIST_HOTSITE_SLOTS
    },
  },
  methods: {
    goToHotsiteSlot(hotsiteSlot) {
      this.$router.push({
        name: 'edit-hotsite-slot',
        params: {
          id: hotsiteSlot._id,
        },
      })
    },
    async addHotsite(name) {
      await this.$apollo.mutate({
        mutation: ADD_HOTSITE_SLOT,
        variables: { name },
      })
      this.$refs.table.waitAndGetData()
    },
    openUrl(url) {
      // Ensure absolute URLs opening to avoid treating as relative paths
      if (!/^https?:\/\//i.test(url)) {
        url = 'https://' + url
      }
      window.open(url, '_blank')
    },
    async deleteHotsiteSlot(hotsiteSlot) {
      const confirmed = await this.$confirm({
        title: 'Remover hotsite',
        message: `Tem certeza que deseja remover o hotsite "${hotsiteSlot.name}"?`,
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      try {
        await this.$apollo.mutate({
          mutation: DELETE_HOTSITE_SLOT,
          variables: { hotsiteSlotId: hotsiteSlot._id },
        })
        this.$refs.table.waitAndGetData()
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao deletar hotsite.', snackbarColor: 'error' })
      }
    },
  },
}
</script>
